import { Match } from "model/Match/Match";
import { MatchTeamsList } from "./List/MatchTeamsList";
import { getNumTeams } from "model/Match/MatchTeams";

interface Props {
  match: Match;
  tournamentId: string;
  showTrackScores: boolean;
}

export const MatchTeams = ({ match, tournamentId, showTrackScores }: Props) => {
  const numTeams = getNumTeams(match.teams);
  if (numTeams <= 10) {
    return (
      <MatchTeamsList
        match={match}
        tournamentId={tournamentId}
        showTrackScores={showTrackScores}
      />
    );
  }

  return <></>;
};
